import React, { ChangeEvent, useContext, useEffect, useRef, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTowerBroadcast } from '@fortawesome/free-solid-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import {
  CheckboxWithLabel,
  SelectOptions,
  SelectWithLabel,
  TextInputWithLabel,
} from './InputWithLabel'
import { CHANNEL_PATH, DEFAULT_CHANNEL_ID } from './constants'
import realtimeService from './RealtimeService'
import UserContext, { UserContextType } from './UserContext'

type ChannelMap = {
  [channelId: string]: boolean
}

const ChannelSettings = () => {
  const {
    userContext: { isBroadcasting, channelId },
    setIsBroadcasting,
    setChannelId,
  } = useContext(UserContext) as UserContextType
  const channelMenuRef = useRef<HTMLSelectElement>(null)
  const channelIdFieldRef = useRef<HTMLInputElement>(null)
  const channelStatusCheckboxRef = useRef<HTMLInputElement>(null)
  const [isCreateChannelEnabled, setIsCreateChannelEnabled] = useState(false)
  const [channelMap, setChannelMap] = useState<ChannelMap>({})
  const [channelMenu, setChannelMenu] = useState<SelectOptions>([])
  const [isInited, setIsInited] = useState(false)
  const CHANNELS_PATH = 'users/kirlen/channels'
  useEffect(() => {
    if (!isInited) {
      realtimeService.endpointOnce(CHANNELS_PATH, {}).then((value) => {
        const chanMap = { ...(value as ChannelMap) }
        if (!(DEFAULT_CHANNEL_ID in chanMap)) {
          channelMap[DEFAULT_CHANNEL_ID] = false
        }
        setChannelMap(chanMap)
        setIsInited(true)
      })
    }
  }, [isInited])
  useEffect(() => {
    const newChannelMenu = Object.keys(channelMap).map((chanId) => {
      const isActive = channelMap[chanId]
      return {
        name: `${isActive ? '*' : '-'} ${chanId}`,
        value: chanId,
      }
    })
    setChannelMenu(newChannelMenu)
    if (channelStatusCheckboxRef.current) {
      channelStatusCheckboxRef.current.checked = channelMap[channelId]
    }
  }, [channelId, channelMap, channelStatusCheckboxRef, channelMenuRef])
  useEffect(() => {
    const index = channelMenu.findIndex(({ value }) => {
      return value === channelId
    })
    if (index >= 0 && channelMenuRef.current) {
      channelMenuRef.current.selectedIndex = index
    }
  }, [channelId, channelMenu, channelMenuRef])
  const onNewChannelNameChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const newName = event.currentTarget.value
    setIsCreateChannelEnabled(newName.length > 3 && !newName.includes(' '))
  }
  const toggleBroadcast = () => {
    // setChannelId(workingChannelId)
    setIsBroadcasting(!isBroadcasting)
  }
  const onChannelStatusToggled = (event: ChangeEvent<HTMLInputElement>) => {
    const isChannelActive = event.target.checked
    setChannelMap((prevChannelMap) => {
      return {
        ...prevChannelMap,
        [channelId]: isChannelActive,
      }
    })
    // setChannelId(workingChannelId)
    realtimeService.set(`${CHANNEL_PATH}/${channelId}/control/isActive`, isChannelActive)
    realtimeService.set(`${CHANNELS_PATH}/${channelId}`, isChannelActive)
  }
  const onChannelChanged = (event: ChangeEvent<HTMLSelectElement>) => {
    const newChannelId = event.currentTarget.value
    setChannelId(newChannelId)
  }
  return (
    <div className="channelSettings">
      <div>
        <SelectWithLabel
          onRef={channelMenuRef}
          itemArray={channelMenu}
          label="channel"
          value="sabile2"
          onChange={onChannelChanged}
          isReadOnly={isBroadcasting}
        />
        <CheckboxWithLabel
          onRef={channelStatusCheckboxRef}
          label="active"
          value={false}
          onChange={onChannelStatusToggled}
          isReadOnly={isBroadcasting}
        />
        <button onClick={toggleBroadcast} disabled={!channelMap[channelId]}>
          <FontAwesomeIcon
            icon={faTowerBroadcast as IconProp}
            color={isBroadcasting ? 'red' : 'gray'}
            title={`${isBroadcasting ? 'Start' : 'Stop'} Broadcasting`}
            size="lg"
          />
        </button>
      </div>
      <div>
        <TextInputWithLabel
          onRef={channelIdFieldRef}
          label=""
          value=""
          onChange={onNewChannelNameChanged}
          isReadOnly={isBroadcasting}
          placeholder="channel name"
        />
        <button disabled={!isCreateChannelEnabled}>create</button>
        <button disabled={true}>delete</button>
      </div>
    </div>
  )
}

export default ChannelSettings
